import { useEffect } from 'react';
import { DOCKET_PREFIX_PATH } from 'react-components/app/routing/routes/docket.routes';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { Button, SingleCardPage } from '@act/storybook';
import { authService } from 'redux/utils/auth/auth-service';
import useIsAuthenticated from 'redux/utils/auth/is-authenticated-hook';
import GoogleIcon from '@mui/icons-material/Google';

export interface LoginProps {
  login: () => void;
}

const Login = () => {
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();

  const login = () => {
    void authService.login();
  };

  useEffect(() => {
    if (isAuthenticated) {
      navigate(`${DOCKET_PREFIX_PATH}`, {
        replace: true,
      });
    }
  }, [isAuthenticated, navigate]);

  return (
    <SingleCardPage showReemaLogo={true}>
      <Typography variant="headlineLarge" align="center">
        Welcome
      </Typography>
      <Typography variant="bodyLarge" align="center">
        Login to Reema Health to continue to Reema App.
      </Typography>
      <Button variant="outlined" debounced onClick={login}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <GoogleIcon />
          Login with Google
        </Box>
      </Button>
    </SingleCardPage>
  );
};

export default Login;
